<template>
  <div>
    <v-alert
      v-if="!appStore.loadingCustomer"
      text
      outlined
      prominent
      class="mx-3 mx-lg-0 mt-3 mt-lg-0"
      :class="!$vuetify.breakpoint.mdAndDown ? 'rounded-pill' : 'rounded-lg'"
      :type="!$vuetify.breakpoint.mdAndDown ? 'warning' : 'error'"
    >
      <div class="text-body-2 text-lg-subtitle-2 font-weight-black">Müşteri Seçiniz</div>
      <div class="text-caption text-lg-caption">
        Bilgilerini görmek istediğiniz müşteriyi yukarıdan seçin
      </div>
    </v-alert>
    <v-alert
      v-else
      text
      outlined
      prominent

      class="mx-3 mx-lg-0 mt-3 mt-lg-0"
      :class="!$vuetify.breakpoint.mdAndDown ? 'rounded-pill' : 'rounded-lg'"
      type="info"
    >
      <div class="text-body-1 text-lg-h6 font-weight-black">Lütfen Bekleyin</div>
      <div class="text-caption text-lg-subtitle-2">Müşteri listesi için veriler çekiliyor</div>
    </v-alert>
  </div>
</template>

<script>
import { useAppStore } from "@/stores/app";
export default {
  setup() {
    const appStore = useAppStore();
    return {
      appStore,
    };
  },
};
</script>

<style></style>
